import React, { useEffect, useState, useRef, Fragment } from 'react';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import TimeAgo from 'react-timeago'
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { styled } from "@mui/material/styles";
import { NetworkStatus } from '@apollo/client';
import { InView } from "react-intersection-observer";
import TableLoadingSkeleton from '../skeletons/TableLoadingSkeleton';
import { AnimatePresence, motion } from "framer-motion";
import NoData from '../empty/NoData';
var _ = require('lodash');
import RowDetail from './RowDetail';



const StyledTableContainer = styled(TableContainer)`
    position: relative;
    background-color: ${(({ theme }) => theme.palette.primary.background)};
    width:100%;
    flex-direction: column;
    display: flex;
    color: ${(({ theme }) => theme.palette.primary.contrastText)};
    `
const StyledTableHead = styled(TableHead)`
    background-color: ${(({ theme }) => theme.palette.primary.dark)};
    color: ${(({ theme }) => theme.palette.primary.contrastText)};
    `

export default function TableView(props) {
    const location = useLocation()
    const [open, setOpen] = useState(false);
    const [openRow, setOpenRow] = useState("");
    const [header, setHeader] = useState(null);
    const [rowData, setRowData] = useState(null);
    const [tableKeys, setTableKeys] = useState(null);

    const {
        data,
        tableSize,
        pageInfo,
        networkStatus,
        fetchMore,
        loading,
        called,
        noDataMessage,
        noDataImage,
        stickyHeader,
        keysToRemove,
        keysToKeep,
        cursor,
        setCursor,
        orderBy,
        order,
        nestedField,
        otherFields,
        relayPagination,
        expandable,
        rowClick,
        rowDetails,
        rowDetailsVariable,
        rowDetailsKeysToExclude,
    } = props


    function handleOnClick(obj) {
        setOpenRow(obj.id)
        setOpen(!open)
        rowClick({
            variables: { [rowDetailsVariable]: obj[rowDetailsVariable] }
        })
    }


    useEffect(() => {
        // console.log(open, openRow, "this is open setup after click")
    }, [open, openRow]);


    function getKeys(data) {
        if (keysToKeep !== undefined && data != undefined) return keysToKeep.concat(['id'])
        if (keysToRemove !== undefined && data != undefined)
            return _.uniq(_.difference(Object.keys(
                nestedField
                    ? data[nestedField] : data),
                keysToRemove).concat(['id']))
        if (keysToKeep === undefined && keysToRemove === undefined && (data != undefined || data != null)) return Object.keys(nestedField ? data[nestedField] : data)
    }


    function processData(data) {
        let processedArr = nestedField && nestedField.length > 0
            ? data.map((obj) => {
                let field = _.get(obj, nestedField);
                let otherFieldsArr = otherFields && _.pick(obj, otherFields);
                // console.log(field, otherFieldsArr, "this is processed and original")
                let combined = Object.assign({}, field, otherFieldsArr);
                return combined;
            })
            : data
        // console.log(processedArr, "this is processed array")
        var deduplicatedData = _.uniqBy(processedArr, 'id');
        // console.log(deduplicatedData, "this is deduplicated data")
        var orderedData = orderBy ? _.orderBy(deduplicatedData, [orderBy], [order]) : deduplicatedData;
        // console.log(orderedData, "this is orderedData data")
        var keys = getKeys(orderedData[0])
        // console.log(keys, "this is orderedData data")
        const redux = array => array.map(o => keys.reduce((acc, curr) => {
            acc[curr] = o[curr];
            return acc;
        }, {}));
        var items = redux(orderedData);
        // console.log(items, keys, "these are processed data and keys")
        return [items, keys]
    }




    function getHeader(keys) {
        return (
            <TableRow key={`table-header`}>
                <TableCell key={`table-index`} >
                    S No.
                </TableCell >
                {keys.map((key, index) => {
                    return (
                        <TableCell key={key} >
                            {key == "id" ? "" : _.startCase(key)}
                        </TableCell>)
                })}
                <TableCell />
            </TableRow>
        )
    }


    const RenderRow = ({ index, data, keys }) => {
        // console.log(data, data.id, open, openRow, data.id == openRow)
        return (
            <Fragment >
                <TableRow
                    sx={{ '& > *': { borderBottom: 'unset' } }}

                // onClick={() => handleOnClick(data)}
                // onClick={(row) => setOpenRow(row.id)}
                >
                    <TableCell key={`main-table-index-${index}`} >
                        {index + 1}
                    </TableCell>

                    {_.pull(keys, "id").map((key, index) => {


                        return (
                            <TableCell key={`${key}-${index}`} component={key == "title" ? "th" : "td"} scope={key == "title" ? "row" : "cell"} >
                                {(Array.isArray(data[key]) && data[key].length > 0)
                                    ? data[key][0]['name']
                                    : (typeof data[key] === 'object' && data[key] != null) ? data[key]['name']
                                        : ["time", "lastVisit", "lastLogin", "date"].some(substring => key.includes(substring))
                                            ? <TimeAgo date={data[key]} formatter={(value = 0, unit = 'hour', suffix = 'ago') => `${value} ${unit} ${suffix}`} locale="en-US" timestyle="twitter" />
                                            : (typeof data[key] == "boolean") ? String(_.startCase(data[key])) : (data[key])}

                            </TableCell>)

                    }
                    )}
                    {expandable &&
                        <TableCell key={`main-table-expand-row-icon-${data.id}`} >
                            <IconButton
                                aria-label="expand row"
                                size="small"
                                onClick={() => handleOnClick(data)}
                            // key={`cell-detail-expand-icon-${data.id}`}
                            >
                                {open && openRow == data.id ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                        </TableCell>
                    }
                </TableRow >
                {expandable &&
                    <TableRow  >
                        <TableCell key={`main-table-expanded-row-index-${data.id}`} style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}  >
                            <Collapse in={open && openRow == data.id} timeout="auto" unmountOnExit >
                                {/* {row.id} */}
                                <RowDetail data={rowDetails} index={index} keys={keys} loading={loading} rowDetailsKeysToExclude={rowDetailsKeysToExclude} />
                            </Collapse>
                        </TableCell>
                    </TableRow>
                }
            </Fragment>
        )
    }

    useEffect(() => {
        if (data !== undefined && data != null) {
            setRowData(processData(data))
        }
    }, []);

    useEffect(() => {
        if (data != undefined && data != null && _.isEmpty(data) != true) {
            // console.log(typeof data, data, "this is table data")
            const [items, keys] = processData(data)
            setRowData(items)
            setTableKeys(keys)
            // console.log(items, keys, "these are frocessed data, next will be loading to table")
        }
        if (_.isEmpty(data) == true) {
            setRowData([])
            // console.log(data, _.isEmpty(data), "row data is empty")
        }
    }, [data]);

    useEffect(() => {
        if (rowData != null && rowData !== undefined && _.isEmpty(rowData) != true) {
            setHeader(getHeader(tableKeys))
        }
    }, [rowData]);

    return (
        <React.StrictMode>
            <AnimatePresence>
                <motion.div
                    key={`${location.pathname.replace("/", "-")}- table`}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    <StyledTableContainer component={Paper}>
                        {_.isEmpty(data) ? <NoData message={noDataMessage} imageName={noDataImage} />
                            :
                            <Table
                                stickyHeader={stickyHeader}
                                aria-label={"collapsible table"}
                                size={tableSize ? tableSize : null} >
                                <StyledTableHead>
                                    {rowData === null
                                        ? <TableLoadingSkeleton key={`table-header-skeleton`} variant={"rectangular"} marginx={0} marginy={0} count={1} height={60} part={"header"} />
                                        : header
                                    }
                                </StyledTableHead>
                                <TableBody key={`table-body`} >
                                    {(rowData === null || rowData === undefined)
                                        ? <TableLoadingSkeleton key={`table-body-skeleton`} variant={"rectangular"} marginx={1} marginy={3} count={15} part={"body"} />
                                        : rowData.map((row, index) => (<RenderRow key={row.id} index={index} data={row} keys={tableKeys} />))}

                                </TableBody>
                            </Table>
                        }
                        {(relayPagination == true && rowData !== null && called && pageInfo !== undefined && pageInfo !== null && pageInfo.hasNextPage === true) && (<TableLoadingSkeleton key={`table-body-skeleton-partial`} variant={"rectangular"} marginx={1} marginy={3} count={5} partial={true} part={"body"} />)}
                        {relayPagination == true && rowData !== null && networkStatus !== NetworkStatus.fetchMore && pageInfo !== undefined && pageInfo !== null && pageInfo.hasNextPage === true && (
                            <InView
                                onChange={async (inView) => {
                                    if (inView) {
                                        setCursor(pageInfo.endCursor)
                                        const result = await fetchMore(
                                            {
                                                variables: {
                                                    cursor: cursor,
                                                },
                                            }
                                        );
                                        console.log("this is fetch more result", result)
                                    }
                                }}
                                threshold={0.5}

                            />
                        )}
                    </StyledTableContainer>
                </motion.div>
            </AnimatePresence>
        </React.StrictMode>
    );

}
